import { PassCategory } from "../../../api/membership";
// 사용/기간만료 탭 페이지 크기
export const EXPIRED_PAGE_SIZE = 10;
// 카테고리별 1차 뱃지 컬러
export const PASS_CATEGORY_TAG_COLOR = {
    [PassCategory.Expert]: "mint",
    [PassCategory.Ticket]: "blue",
    [PassCategory.FreePass]: "indigo"
};
// 카테고리별 카드 썸네일 — 서버 응답에 의존하지 않고 카테고리 단위로 고정.
export const PASS_CATEGORY_THUMBNAIL = {
    [PassCategory.Ticket]: "/static/assets/default-image/ticket.svg",
    [PassCategory.FreePass]: "/static/assets/default-image/freepass.svg",
    [PassCategory.Expert]: "/static/assets/default-image/expert.svg"
};
// 뱃지 대상 밖 카테고리(구독 계열 등)용 썸네일 — 카테고리를 특정하지 않는 중립 이미지
export const DEFAULT_PASS_THUMBNAIL = "/static/assets/default_pass.png";
